import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "@/LanguageContext";

export default function MarqueeStrip() {
  const { t } = useLang();
  return (
    <section data-testid="marquee-strip" className="relative bg-navy border-y border-white/10 py-6 marquee-fade">
      <Marquee speed={26} gradient={false} autoFill>
        {t.marquee.map((word, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-3xl sm:text-5xl text-white/85 px-8">{word}</span>
            <span className="text-gold text-2xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
